import { render } from "./AddAmendmentModal.vue?vue&type=template&id=2f2319b6&scoped=true"
import script from "./AddAmendmentModal.vue?vue&type=script&lang=js"
export * from "./AddAmendmentModal.vue?vue&type=script&lang=js"

import "./AddAmendmentModal.vue?vue&type=style&index=0&id=2f2319b6&lang=stylus&scoped=true"
import "./AddAmendmentModal.vue?vue&type=style&index=1&id=2f2319b6&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2319b6"]])

export default __exports__